import { useEffect } from "react";
import OrderBookTable from "../../Tables/Order/OrderBookTable";
import { useAppSelector } from "../../App/hooks";
import useRequest from "../../Hooks/useRequest";
import { getMarketmakingOrderbookPair } from "../../Requests/deltaHedgeMarketmaking";
import { addSeperatorToInput } from "../../helper";

const Orderbook = () => {
  const taskId = useAppSelector(
    (store) => store.deltaHedgeMarketmaking.clickedTaskTableRowValues?.id
  );

  const orderBookRequest = useRequest(
    () => getMarketmakingOrderbookPair(taskId?.toString() || ""),
    (e) => {}
  );

  useEffect(() => {
    if (!taskId) return;
    orderBookRequest.fetchData();
    const interval = setInterval(() => {
      orderBookRequest.fetchData();
    }, 5000);
    return () => clearInterval(interval);
  }, [taskId]);

  const getKeyValueJSX = (title: string, value: string) => (
    <div className="flex flex-row justify-start items-center gap-3 text-xs">
      <div className="font-bold whitespace-nowrap">{title}:</div>
      <div className="ltr">{value}</div>
    </div>
  );

  return (
    <div className="flex flex-col justify-start items-center mx-auto gap-3 border border-gray-300 rounded p-3 h-auto w-full">
      <div className="w-full overflow-x-auto p-2">
        <OrderBookTable
          tableInfo={orderBookRequest?.response?.fullOrderBook}
          openOrders={orderBookRequest?.response?.openOrders}
        />
      </div>
      <div className="grid grid-cols-2 gap-x-5 gap-y-3">
        {getKeyValueJSX(
          "% بازده لحظه ای سفارش خرید",
          orderBookRequest?.response?.dailyLockProfitBuy
            ? addSeperatorToInput(
                orderBookRequest?.response?.dailyLockProfitBuy?.toString(),
                "priceWithDecimal"
              )
            : "-"
        )}
        {getKeyValueJSX(
          "% بازده لحظه ای سفارش فروش",
          orderBookRequest?.response?.dailyLockProfitSell
            ? addSeperatorToInput(
                orderBookRequest?.response?.dailyLockProfitSell?.toString(),
                "priceWithDecimal"
              )
            : "-"
        )}

        {getKeyValueJSX(
          "قیمت محاسباتی خرید",
          orderBookRequest?.response?.calcBuyPrice
            ? addSeperatorToInput(
                orderBookRequest?.response?.calcBuyPrice?.toString(),
                "priceWithDecimal"
              )
            : "-"
        )}
        {getKeyValueJSX(
          "قیمت محاسباتی فروش",
          orderBookRequest?.response?.calcSellPrice
            ? addSeperatorToInput(
                orderBookRequest?.response?.calcSellPrice?.toString(),
                "priceWithDecimal"
              )
            : "-"
        )}
      </div>
    </div>
  );
};

export default Orderbook;
